import { useState, useEffect } from "react";
import { listInvestigationRoadAccidentService } from "../services/listInvestigationRoadAccident.service";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";

const LIMIT = 20;

export const useInvestigationAccidentQuery = (filters) => {
  const fetchData = useFetch();
  const [investigationAccidents, setInvestigationAccidents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    const fetchInvestigationAccidents = async () => {
      try {
        setLoading(true);
        const response = await listInvestigationRoadAccidentService(fetchData)({
          limit: LIMIT,
          offset: (currentPage - 1) * LIMIT,
          ...filters,
        });

        setInvestigationAccidents(response.data);
        setTotalItems(response.total);
        setTotalPages(response.totalPages);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchInvestigationAccidents, 500);
    debouncedFetch();
    return () => {
      debouncedFetch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, currentPage, filters]);

  return {
    investigationAccidents,
    loading,
    currentPage,
    totalPages,
    totalItems,
    refresh: () => setRefresh((prev) => !prev),
    onChangePage: (page) => setCurrentPage(page),
  };
};
